import {Component, OnInit} from '@angular/core';
import {LifeProject} from '../../class/lifeproject/life-project';
import {WelfareResultService} from '../../service/welfare-result.service';
import {ApiService} from '../../service/api.service';
import {UniversityProject} from '../../class/lifeproject/university-project';
import {BoardProject} from '../../class/lifeproject/board-project';
import {BuildMoneyProject} from '../../class/lifeproject/build-money-project';
import {FinantialProject} from '../../class/lifeproject/finantial-project';

@Component({
  selector: 'app-life-projects',
  templateUrl: './life-projects.component.html',
  styleUrls: ['./life-projects.component.css']
})
export class LifeProjectsComponent implements OnInit {

  lifeProjects: LifeProject[] = [];
  rapIncomeDebt = 0;

  constructor(private welfareProject: WelfareResultService, private apiService: ApiService) {
  }

  ngOnInit() {
    this.apiService.loadLifeProjects().subscribe(value => {
      this.lifeProjects = value;
    });
  }

  addProject(project: LifeProject) {

    let selProject = null;

    switch (project.type) {
      case 0: {
        selProject = new UniversityProject();
      }
        break;
      case 2: {
        selProject = new BoardProject();
      }
        break;

      case 3: {
        selProject = new BuildMoneyProject();
      }
        break;

      case 4: {
        selProject = new FinantialProject();
      }
        break;
    }

    if (selProject) {

      // set name to sel project
      selProject.name = project.name;

      // add project
      this.welfareProject.lifeProjects.push(selProject);
    }
  }

  get lifeProject() {
    return this.welfareProject.lifeProjects;
  }

  private projectAsUniProject(project): UniversityProject {
    return project;
  }

  computeRapIncome() {

    let totalDebt = 0;

    this.lifeProject.forEach(project => {
      if (project.type === 4) {
        totalDebt += project.yearCost;
      }
    });

    if (totalDebt > 0) {

      // sum debts
      totalDebt += this.getTotalDebts();

      this.rapIncomeDebt = totalDebt / this.getTotalIncome();
    }
  }

  private getTotalDebts(): number {

    let totalYearDebts = 0;

    this.welfareProject.debt.forEach(value => {
      if (value.name !== 'Assegno Figli' && value.name !== 'Affitto') {
        totalYearDebts += value.debtYear;
      }
    });

    return totalYearDebts;
  }

  private getTotalIncome(): number {
    let ret = 0;

    this.welfareProject.persons.forEach(value => {
      ret += value.income + value.secondIncome;
    });

    return ret;
  }

}

